'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectReportSkippedUsers = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProjectReportSkippedUsers, _Component);

  function ProjectReportSkippedUsers() {
    (0, _classCallCheck3.default)(this, ProjectReportSkippedUsers);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportSkippedUsers.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportSkippedUsers)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectReportSkippedUsers, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          reportData = _props.reportData;
      var _reportData$nonViewer = reportData.nonViewers,
          nonViewers = _reportData$nonViewer === undefined ? [] : _reportData$nonViewer;


      if (!nonViewers.length) {
        return _react2.default.createElement(_components.NoRecords, null);
      }

      return _react2.default.createElement(
        _components.List,
        null,
        _react2.default.createElement(
          _components.ListItem,
          { fullWidth: true, isTitle: true },
          _react2.default.createElement(
            'div',
            null,
            'ID'
          ),
          _react2.default.createElement(
            'div',
            null,
            t('Name')
          ),
          _react2.default.createElement(
            'div',
            null,
            t('Email')
          )
        ),
        nonViewers.map(function (recipient) {
          return _react2.default.createElement(
            _components.ListItem,
            {
              key: recipient.recipientId,
              fullWidth: true
            },
            _react2.default.createElement(
              'div',
              null,
              recipient.recipientId
            ),
            _react2.default.createElement(
              'div',
              null,
              recipient.fullName
            ),
            _react2.default.createElement(
              'div',
              null,
              recipient.email
            )
          );
        })
      );
    }
  }]);
  return ProjectReportSkippedUsers;
}(_react.Component), _class2.propTypes = {
  reportData: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = ProjectReportSkippedUsers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectReport/ProjectReportSkippedUsers.js
// module id = 2060
// module chunks = 1